import { Tooltip } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "AppContext";
import { CommonPagination, GKModal, GKTable, StatusField } from "components";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";
import axiosInstance from "utils/axiosInstance";
import { extraColumnsField } from "utils/helpers";

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const CnsModal = ({ open, setOpen }: Props) => {
  const { id } = useParams();

  const {
    state: { commonFilter },
  } = useAppContext();

  const requestBody = {
    requireTotalCount: true,
    take: commonFilter?.advisorWise?.take,
    skip: commonFilter?.advisorWise?.skip,
    sort: JSON.stringify(
      commonFilter?.advisorWise?.sortModel?.map((data: any) => {
        return {
          selector: data.field,
          desc: data.sort !== "asc",
        };
      })
    ),
    search: commonFilter?.advisorWise?.search || "",
  };

  const { data: advisorWiseData, isLoading } = useQuery({
    queryKey: ["GET_ADVISOR_WISE", requestBody],
    queryFn: () =>
      axiosInstance.get(`/super_admin/${id}/advisor_wise_cn/`, {
        params: requestBody,
      }),
  });

  const cusPagination = () => {
    return (
      <CommonPagination
        name="advisorWise"
        totalCount={advisorWiseData?.data?.totalCount || 0}
      />
    );
  };

  const columns: GridColDef[] = [
    {
      ...extraColumnsField("Broker", "broker", 120, 1),
    },
    {
      ...extraColumnsField("Format", "format", 120, 1),
      renderCell: (params) => (
        <Tooltip title={params.value || ""} arrow>
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "100%",
            }}
          >
            {params.value || "-"}
          </div>
        </Tooltip>
      ),
    },
    {
      ...extraColumnsField("Source", "source", 120, 1),
    },
    {
      ...extraColumnsField("Status", "status", 120, 1),
      valueGetter: (row) => row?.row?.status || "-",
      renderCell: (props) => {
        return <StatusField statusString={`${props?.row?.status}`} />;
      },
    },
    {
      ...extraColumnsField("Uploaded Date", "uploadedDate", 100, 1),
      valueFormatter: (data) => dayjs(data?.value).format("DD-MM-YYYY"),
    },
  ];

  return (
    <GKModal modalTitle="CNS" open={open} setOpen={setOpen}>
      <GKTable
        columns={columns}
        rows={advisorWiseData?.data?.data || []}
        loading={isLoading}
        maxHeight="300px"
        name="advisorWise"
        CustomPagination={!isLoading && cusPagination}
      />
    </GKModal>
  );
};

export default CnsModal;
